// The question types a form can hold, in the order they appear in the type
// picker. Shared by the builder's <select> and the collapsed-card badge so the
// two can never drift apart.
export const FIELD_TYPES = [
  { value: 'text', label: 'Text' },
  { value: 'number', label: 'Number' },
  { value: 'date', label: 'Date' },
  { value: 'select', label: 'Dropdown' },
  { value: 'photo', label: 'Photo' },
  { value: 'contact', label: 'Contact' },
  { value: 'calculation', label: 'Calculation' },
];

export const fieldTypeLabel = (type) =>
  FIELD_TYPES.find((entry) => entry.value === type)?.label || 'Text';
